import * as messageService from "../../services/message.service";
import * as salaryPackagingProviderService from '../../services/salaryPackagingProvider.service';


const state = {
    salaryPackagingProviderAll:[],
    salaryPackagingProviderAllActive:[],
};

const getters = {
    gettSalaryPackagingProviderAll:state => (state.salaryPackagingProviderAll),
    gettSalaryPackagingProviderAllActive:state => (state.salaryPackagingProviderAllActive),
};

const actions = {
    async fetchSalaryPackagingProviderAll({ commit } ){
        try {
            const response = await salaryPackagingProviderService.all();
            commit('setSalaryPackagingProviderAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchSalaryPackagingProviderAllActive({ commit } ){
        try {
            const response = await salaryPackagingProviderService.allActive();
            commit('setSalaryPackagingProviderAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setSalaryPackagingProviderAll:(state, res) => (
        state.salaryPackagingProviderAll =  res
    ),
    setSalaryPackagingProviderAllActive:(state, res) => (
        state.salaryPackagingProviderAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}